import React, { useContext } from 'react';
import {
  Box, Card, CardContent, Typography, Grid, LinearProgress,
  IconButton, Tooltip, Stack, Chip, alpha, Container
} from '@mui/material';
import {
  AiOutlineFileDone,
  AiOutlineHome
} from 'react-icons/ai';
import {
  BiTimeFive,
  BiCheckCircle
} from 'react-icons/bi';
import { FaCertificate } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { backendURL, baseApiUrl } from 'redux/reducers/settings';
import { useGetTrainingRoutineQuery } from 'redux/reducers/user/dashboard';
import NascLogo from '../../../assets/images/logo-narc.png';
import { ConfigurationContext } from 'components/provider/OrginazationContext';

const TrainingCompletedCard = () => {
  const navigate = useNavigate();
  const { data: completedTraining = [] } = useGetTrainingRoutineQuery('completed');
  const { appConfig } = useContext(ConfigurationContext)


  return (
    <Container maxWidth="xl" sx={{ py: 3, px: 0 }}>
      {!completedTraining.length ? (
        <Box
          sx={{
            textAlign: 'center', py: 10, bgcolor: 'background.paper',
            borderRadius: 4, border: '1px solid', borderColor: 'divider'
          }}
        >
          <BiCheckCircle size={60} style={{ opacity: 0.2, marginBottom: '16px' }} />
          <Typography variant="h6" color="text.secondary" fontWeight={600}>
            You have not completed any training yet.
          </Typography>
        </Box>
      ) : (
        <Grid container spacing={3}>
          {completedTraining.map((item: any) => (
            <Grid item xs={12} sm={6} lg={4} xl={3} key={item.id}>
              <Card
                onClick={() => navigate(`/training/${item.id}`)}
                elevation={0}
                sx={{
                  cursor: "pointer",
                  height: '100%', borderRadius: 4, border: '1px solid', borderColor: 'divider',
                  transition: 'all 0.3s ease',
                  '&:hover': { transform: 'translateY(-6px)', boxShadow: '0 12px 24px rgba(0,0,0,0.08)' }
                }}
              >
                {/* Image Header */}
                <Box sx={{ position: 'relative', bgcolor: '#f8f9fa', p: 4, textAlign: 'center', borderBottom: '1px solid', borderColor: 'divider' }}>
                  <img
                    src={item.training?.image ? backendURL + item.training?.image : backendURL + appConfig?.logo}
                    alt="Training"
                    style={{ height: '100px', objectFit: 'contain' }}
                  />
                  <Chip
                    icon={<BiCheckCircle color="white" />}
                    label="Completed"
                    color="success"
                    size="small"
                    sx={{
                      position: 'absolute', top: 12, right: 12,
                      fontWeight: 700, borderRadius: 1.5, px: 1
                    }}
                  />
                </Box>

                <CardContent sx={{ p: 3 }}>
                  {/* Title and Duration */}
                  <Typography variant="subtitle1" sx={{ fontWeight: 800, mb: 0.5, height: 48, overflow: 'hidden', lineHeight: 1.3 }}>
                    {item?.training?.training_name}
                  </Typography>

                  <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 3 }} color="text.secondary">
                    <BiTimeFive size={16} />
                    <Typography variant="caption" fontWeight={600}>
                      Full Duration Completed
                    </Typography>
                  </Stack>

                  {/* Progress Section */}
                  <Box sx={{ mb: 4 }}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
                      <Typography variant="caption" color="success.main" sx={{ fontWeight: 800, textTransform: 'uppercase' }}>
                        Course Mastery
                      </Typography>
                      <Typography variant="caption" sx={{ fontWeight: 800 }}>100%</Typography>
                    </Stack>
                    <LinearProgress
                      variant="determinate"
                      value={100}
                      color="success"
                      sx={{ height: 8, borderRadius: 4, bgcolor: alpha('#2e7d32', 0.1) }}
                    />
                  </Box>


                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </Container>
  );
};

export default TrainingCompletedCard;